class ScrollAnimations {
  constructor() {
    this.init();
  }

  init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.documentElement.classList.add('reduced-motion');
      return;
    }

    const animationConfig = {
      threshold: 0.1,
      rootMargin: '0px 0px -5% 0px'
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-animated');
        } else if (!entry.target.hasAttribute('data-animate-once')) {
          entry.target.classList.remove('is-animated');
        }
      });
    }, animationConfig);

    this.observeElements();

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => this.observeElements());
    }
  }

  observeElements() {
    const animatableElements = document.querySelectorAll('[data-animate]');
    animatableElements.forEach((el) => {
      this.observer.observe(el);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ScrollAnimations();
});

if (document.readyState === 'interactive' || document.readyState === 'complete') {
  new ScrollAnimations();
}
